class I18nUtils {
    /**
     * Zwraca komunikat błędu z odpowiedzi API.
     * Sprawdza errorCode w errorKey, fallback na message lub global.errorMessage.
     * @param {Object} err - błąd z API { errorCode, message } lub zwykły { message }
     * @param {Function} t - funkcja t() z i18next
     */
    static getApiErrorMessage(err, t) {
        if (!err) return t('global.errorMessage');
        const errorKey = err?.errorCode;
        if (errorKey) {
            const translated = t(`errorKey.${errorKey}`);
            if (translated !== `errorKey.${errorKey}`) return translated;
        }
        const msg = err?.message;
        if (msg && !msg.startsWith('###')) return msg;
        return t('global.errorMessage');
    }

    static getSupportedLanguages(a) {
        let supportedLanguages = ['pl'];
        const supportedLanguagesFromStorage = localStorage.getItem('supportedLanguages');
        try {
            if (supportedLanguagesFromStorage !== undefined && supportedLanguagesFromStorage !== null) {
                const supportedLanguagesFromStorageArray = supportedLanguagesFromStorage.split(',');
                supportedLanguages = supportedLanguagesFromStorageArray;
            }
        } catch (err) {
            console.log('getSupportedLanguages error', err);
        }
        return supportedLanguages;
    }
}

export default I18nUtils;
